var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextField',{attrs:{"id":_vm.id,"label":_vm.label,"rules":_vm.documentNumberRules,"placeholder":_vm.placeholder,"value":_vm.value,"disabled":_vm.disabled,"type":_vm.type},on:{"beforeinput":_vm.preventInvalidInput,"updateValue":function($event){return _vm.$emit('updateValue', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }